import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestListPayAndCapturePromotion', {
    payDescription: 'Pay approved bills directly from ApprovalMax',
    captureDescription:
        'Say goodbye to manual data entry!{br} Automatically extract data from images or PDFs in seconds.',
    tryNowButtonText: 'Try now',
});
